import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

export const getDataUnitList = createAsyncThunk(
  'reportPnbpList/unitList',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/public/version`,
        config,
      )
      const newData = data?.unitList?.split(',')
      const newestData = newData.map((e) => ({
        value: e,
        label: e,
      }))
      return newestData
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const getDataCommodities = createAsyncThunk(
  'reportPnbpList/commodity',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/items?sortby=nameItem&sortdir=asc`,
        config,
      )
      if (data?.totalItems > data?.items.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/items?sortby=nameItem&sortdir=asc&size=${data?.totalItems}`,
          config,
        )
        const newData = res?.data?.items.map((e) => {
          return {
            value: e?.id,
            label: e?.nameItem,
            id: e?.id,
            image: e?.linkFoto,
            sku: e?.SKU,
            categoryName: e?.itemcategory?.categoryName,
            unit: e?.unit,
          }
        })
        return newData
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
